// lokality.cjs — jediný seznam lokalit a normalizace jejich pravopisu.
//
// PROČ (4.9.2026, hlášení Ládi): ve výběru „vede lokalitu" byly vidět DVĚ
// položky pro jedno a to samé místo — „VT GYM" a „VT GYM - Kbely". Důvod nebyl
// v datech, ale v tom, že každá obrazovka nabízela jiný pravopis:
//   • src/pages/Trainers.jsx                 → <option value="VT GYM">
//   • src/components/HRPersonDetailModal.jsx → "VT GYM - Kbely"
// Podle toho, kde se člověk uložil, vznikl jeden nebo druhý zápis a všechno, co
// lokality seskupuje (kapacita, filtry, vedení lokality), je pak bralo jako dvě
// různá místa.
//
// POZOR na dvě různé osy, které se nesmí míchat:
//   1. TAHLE — lidský název lokality u člověka nebo klienta („VT GYM - Kbely").
//   2. Kód pobočky v Reserviu — „VT" / „Kbely" (viz rezervaceLib.mapLokalita).
//      Ten zůstává beze změny, sloupce bookings.lokalita se to netýká.

// Kanonické názvy. Co je tady, to se nabízí ve všech výběrech.
const LOKALITY = ["VT GYM - Kbely", "Sportovní Hala Kbely"];

// Známé pravopisy, které se v systému historicky objevily (Notion, Sheet, starší
// verze formulářů). Klíč je znormalizovaný tvar: bez diakritiky, malá písmena.
const ALIASY = {
  "vt gym": "VT GYM - Kbely",
  "vt gym kbely": "VT GYM - Kbely",
  "vt gym - kbely": "VT GYM - Kbely",
  "praha - kbely - vt gym": "VT GYM - Kbely",
  "praha kbely vt gym": "VT GYM - Kbely",
  "vt": "VT GYM - Kbely",
  "sportovni hala kbely": "Sportovní Hala Kbely",
  "sportovni hala": "Sportovní Hala Kbely",
  "kbely - sportovni hala": "Sportovní Hala Kbely",
  "kbely sportovni hala": "Sportovní Hala Kbely",
};

function klic(s) {
  return String(s || "").trim().toLowerCase()
    .normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, " ");
}

// Vrati kanonicky nazev lokality. Neznamy zapis nechame byt (nechceme ticho
// zahodit lokalitu, kterou zatim neznáme), jen ho orizneme.
function normalizujLokalitu(s) {
  const t = String(s || "").trim();
  if (!t) return "";
  return ALIASY[klic(t)] || t;
}

// Seznam lokalit pro vyber: kanonicke + cokoliv navic, co se opravdu pouziva.
function lokalityProVyber(pouzivane) {
  const set = new Set(LOKALITY);
  for (const l of (pouzivane || [])) {
    const n = normalizujLokalitu(l);
    if (n) set.add(n);
  }
  return [...set].sort((a, b) => a.localeCompare(b, "cs"));
}

export { LOKALITY, normalizujLokalitu, lokalityProVyber };
